require('./helpers/bundle-manifest').register(JSON.parse("{\"lNt4Y\":\"index.01fe5807.js\",\"3GX3x\":\"icon.19846d52.png\"}"));